import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

/**
 * Single gating site for the KPI Sources page: the flag turns the module on
 * and the customer-success permission scopes who sees it. Shared by the route
 * and the admin-panel nav so the condition cannot drift between them.
 */
export function useKpiSourceHierarchyAvailable(): boolean {
  const { showKpiSourceHierarchy } = useFlags<MaggieFeatureFlags>();
  return (
    Boolean(showKpiSourceHierarchy) && PermissionService.get().hasPermission(PermissionKey.customerSuccessAll)
  );
}
